export const useFormValidationRegExps = (field: FormField, model: Ref<any>) => {
  const validation = ref<FormValidation>();
  watchEffect(() => {
    validation.value = getFormValidationRegExps(field, model);
  });
  return validation;
};
